/** A single `@`-mention suggestion (shape produced by useMultiSubmitData). */
export interface MentionOption {
  id: string;
  display: string;
  label: string;
  name: string;
}

/**
 * Build the deduped suggestion list for one row's email cell: drop any mention
 * whose email (`label`) already appears in the row's To/CC/BCC. Matching is
 * trimmed and case-insensitive. Mirrors the single-submit popup behaviour.
 */
export function filterMentionOptions(mentions: MentionOption[], usedRaw: string[]): MentionOption[] {
  const used = new Set(
    usedRaw
      .flatMap((raw) => (raw || '').split(','))
      .map((part) => part.trim().toLowerCase())
      .filter((part) => part !== ''),
  );
  return mentions.filter((mention) => !used.has(mention.label.toLowerCase()));
}
